import { useMemo } from 'react';
import { useInsightsOrganisationDataQuery } from 'src/graphql';

export interface OrganisationInsightsData {
  organisationSites: string[];
  organisationCountries: string[];
  organisationCaseCountries: Array<{ code: string; name: string }>;
  organisationCaseRegions: Array<{
    id: string;
    name: string;
    countryCodes?: string[];
  }>;
  organisationDepartments: string[];
  organisationCategories: string[];
  oldestReportSubmittedDate?: Date;
}

const EMPTY_STRINGS: string[] = [];
const EMPTY_CASE_COUNTRIES: Array<{ code: string; name: string }> = [];
const EMPTY_CASE_REGIONS: Array<{
  id: string;
  name: string;
  countryCodes?: string[];
}> = [];

export const useOrganisationInsightsData = () => {
  const { data } = useInsightsOrganisationDataQuery();
  const org = data?.organisation;

  return useMemo(
    () => ({
      organisationSites: org?.insightsSites ?? EMPTY_STRINGS,
      organisationCountries: org?.insightsCountries ?? EMPTY_STRINGS,
      organisationCaseCountries:
        org?.insightsCaseCountryRegions?.countries ?? EMPTY_CASE_COUNTRIES,
      organisationCaseRegions:
        org?.insightsCaseCountryRegions?.regions ?? EMPTY_CASE_REGIONS,
      organisationDepartments: org?.insightsDepartments ?? EMPTY_STRINGS,
      organisationCategories: org?.insightsCategories ?? EMPTY_STRINGS,
      oldestReportSubmittedDate: org?.oldestReportSubmittedDate,
    }),
    [org],
  );
};
